/**
 * Created by dreamc_t on 2017/4/17.
 */

import './style.scss';
import tmpl from './onlypic.ejs';
import Events from 'f.core.event';
import util from 'f.core.mobile.util';
class OnlyPic {
    constructor(options, message, native) {
        this.options = options;
        this.message = message;
        this.native = native;
        this.initDom();
        this.initEvent();
    }

    initDom() {
        let nowTime = new Date().valueOf();
        if (this.options.start_date > nowTime) {
            // 直播未开始
            this.isLive = '0';
        } else if (nowTime > this.options.end_date) {
            this.isLive = '2'; // 点播
        } else {
            this.isLive = '1';
        }
        this.el = $(tmpl({ options: this.options, isLive: this.isLive, showOnlineNum: window.showOnlineNum || false }));
    }

    initEvent() {
        let self = this;
        this.message.on('online:info', '201', this.changeCount.bind(this));

        this.goBack = this.el[0].querySelector('.linkbox');

        util.tap(this.goBack, function() {
            if (self.native.isApp) {
                self.native.close();
            } else {
                window.open('//izhibo.ifeng.com/home.html');
            }
        });
    }

    changeCount(msg) {
        if (msg.code == 1) {
            console.log(this.el.find('.number'));
            this.el.find('.number').text(formatCount(msg.number));
        }
    }

    renderTo(parentNode) {
        parentNode.appendChild(this.el[0]);
    }

    show() {
        if (this.isShow) {
            $(this.el).show();
            this.isShow = false;
        }
    }

    hide() {
        if (!this.isShow) {
            $(this.el).hide();
            this.isShow = true;
        }
    }
}

let formatCount = function(val) {
    if (val < 10000) {
        return val;
    } else {
        return (val / 10000).toFixed(1) + '万';
    }
};

Events.mixTo(OnlyPic);

export default OnlyPic;



// WEBPACK FOOTER //
// ./app/modules/onlypic/index.js